package org.lennycodes.hldi.pages.admin

import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.px
import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.backend.*
import org.lennycodes.hldi.data.GalleryImage
import org.w3c.dom.HTMLInputElement
import org.w3c.files.File


@Composable
fun UpdateGalleryDialog(
    image: GalleryImage,
    onDismiss: () -> Unit,
    onSuccess: () -> Unit
) {

    val scope = rememberCoroutineScope()


    var title by remember {
        mutableStateOf(image.title)
    }


    var category by remember {
        mutableStateOf(image.category)
    }


    var selectedFile by remember {
        mutableStateOf<File?>(null)
    }


    var isLoading by remember {
        mutableStateOf(false)
    }


    var errorMessage by remember {
        mutableStateOf("")
    }



    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!isLoading) {
                        onDismiss()
                    }
                }

            }
    ) {


        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }

                }
        ) {



            H3(
                attrs = DialogTitleStyle.toAttrs()
            ) {

                Text("Update Gallery Image")

            }




            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {

                    Text("Title")

                }


                Input(

                    type = InputType.Text,

                    attrs = Modifier
                        .padding(11.px,14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            value(title)

                            onInput {
                                title = it.value
                            }


                            if(isLoading){
                                disabled()
                            }

                        }

                )

            }






            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {

                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ) {

                    Text("Category")

                }


                Select(

                    attrs = Modifier
                        .padding(11.px,14.px)
                        .then(FieldInputStyle.toModifier())
                        .toAttrs {

                            onChange {
                                category = it.value.toString()
                            }


                            if(isLoading){
                                disabled()
                            }

                        }

                ) {


                    Option(
                        value = "Education",
                        attrs = {
                            if(category=="Education")
                                selected()
                        }
                    ){
                        Text("Education")
                    }



                    Option(
                        value = "Legal Aid",
                        attrs = {
                            if(category=="Legal Aid")
                                selected()
                        }
                    ){
                        Text("Legal Aid")
                    }



                    Option(
                        value = "Health",
                        attrs = {
                            if(category=="Health")
                                selected()
                        }
                    ){
                        Text("Health")
                    }




                    Option(
                        value = "Community Development",
                        attrs = {
                            if(category=="Community Development")
                                selected()
                        }
                    ){
                        Text("Community Development")
                    }


                }

            }






            Div(
                attrs = FieldGroupStyle.toAttrs()
            ) {


                Label(
                    attrs = FieldLabelStyle.toAttrs()
                ){

                    Text("Replace Image (optional)")

                }



                Input(

                    type = InputType.File,

                    attrs = Modifier.toAttrs {

                        attr(
                            "accept",
                            "image/*"
                        )


                        onChange {
                            val input = it.target
                            selectedFile = input.files?.item(0)
                        }


                        if(isLoading){
                            disabled()
                        }

                    }

                )

            }







            if(errorMessage.isNotEmpty()){

                P(
                    attrs = Modifier
                        .color(
                            Color.rgb(
                                220,
                                53,
                                69
                            )
                        )
                        .toAttrs()
                ){

                    Text(errorMessage)

                }

            }






            Row(

                horizontalArrangement =
                    Arrangement.spacedBy(12.px)

            ){



                Button(

                    enabled = !isLoading,

                    onClick = {
                        onDismiss()
                    }

                ){

                    Text("Cancel")

                }





                Button(

                    enabled = !isLoading,

                    onClick = {


                        scope.launch {


                            try {


                                errorMessage = ""


                                if(title.isBlank()){

                                    errorMessage =
                                        "Title required"

                                    return@launch

                                }


                                isLoading = true



                                var updatedUrl =
                                    image.url


                                var updatedPath =
                                    image.storagePath






                                if(selectedFile != null){


                                    val newId =
                                        image.id



                                    val uploadedImage =
                                        uploadImage(
                                            selectedFile!!,
                                            newId
                                        )


                                    updatedUrl =
                                        uploadedImage.url


                                    updatedPath =
                                        uploadedImage.storagePath



                                    // Delete old storage file now that the new one is uploaded
                                    if(image.storagePath.isNotBlank() && image.storagePath != updatedPath){

                                        try {

                                            val oldRef =
                                                ref(
                                                    FirebaseService.storage,
                                                    image.storagePath
                                                )

                                            deleteObject(oldRef).await()

                                        } catch(e: Throwable) {

                                            console.error(
                                                "Failed to delete old image: ${e.message}"
                                            )

                                        }

                                    }


                                }







                                val updatedImage =
                                    GalleryImage(

                                        id = image.id,

                                        url = updatedUrl,

                                        title = title,

                                        category = category,

                                        storagePath = updatedPath

                                    )

                                setDoc(

                                    doc(

                                        collection(
                                            FirebaseService.db,
                                            "gallery"
                                        ),

                                        image.id

                                    ),

                                    updatedImage.toFirebaseData()

                                ).await()






                                onSuccess()


                                onDismiss()



                            }
                            catch(e:Throwable){


                                errorMessage =
                                    e.message
                                        ?: "Update failed"


                            }
                            finally{

                                isLoading=false

                            }


                        }


                    }

                ){

                    Text(
                        if(isLoading)
                            "Updating..."
                        else
                            "Update"
                    )

                }

            }

        }

    }

}